import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Grid, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import React from 'react';
import { PsBeaconButton } from '../shared/BeaconRegister';
import { Content } from '../shared/Content';
import PastPlanTile from './Tiles/PastPlanTile';
import HubPageBase from './HubPageBase';
import AddPartnerTile from './Tiles/AddPartnerTile';
import InsightsTile from './Tiles/InsightsTile';

const ConsentGiven = ({ state, dispatch }) => {
    const redirectToHub = () => window.location.replace('/usis/advice/fps/profile');
    const smallScreenSize = window.matchMedia('(max-width: 600px)');
    const [serviceError, setServiceError] = React.useState(false);
    const [buttonSize, setButtonSize] = React.useState(
        window.innerWidth <= 600 ? '100%' : 'inherit'
    );
    const [open, setOpen] = React.useState(false);
    const popupAlertText = Content.planBlockedAlert.contentText;
    const popupAlertTitle = Content.planBlockedAlert.contentTitle;

    smallScreenSize.addEventListener('change', function () {
        setButtonSize(smallScreenSize.matches ? '100%' : 'inherit');
    });

    const handlePopupClose = () => {
        setOpen(false);
    };

    return (

        <HubPageBase
            state={state}
            dispatch={dispatch}
            serviceError={serviceError}
            popupAlertTitle={popupAlertTitle}
            popUpError={open}
            popupAlertText={popupAlertText}
            popupClose={handlePopupClose}>
            <Box className="b-container-content" sx={{ inlineSize: 'unset !important' }}>
                <Grid
                    container
                    sx={{
                        width: '100%',
                        paddingTop: '64px',
                        paddingBottom: { xs: '1rem', md: '64px' },
                    }}>
                    <Grid
                        item
                        cols={12}
                        lg={9}
                        sx={{ minHeight: { xs: 'inherit', md: '300px' } }}>
                        <Typography
                            id="consent-given-page-title"
                            type="headline"
                            serif
                            loose
                            scale={400}
                            sx={{ paddingBottom: '48px' }}>
                            Welcome back! Let&apos;s finish your questionnaire
                        </Typography>
                        <Typography
                            id="consent-given-page-content"
                            type="body"
                            loose
                            scale={200}
                            light>
                            Tell us about your goals and timeline for achieving them. Once we
                            know what&apos;s important to you, we can create a personalized plan
                            and review it with you.
                        </Typography>
                        <Box
                            id="finish-questionnaire-button-container"
                            sx={{ paddingTop: '24px' }}>
                            <PsBeaconButton
                                id="finish-questionnaire-button"
                                scale="jumbo"
                                onClick={redirectToHub}
                                style={{ width: buttonSize }}>
                                Finish Questionnaire
                            </PsBeaconButton>
                        </Box>
                    </Grid>
                    {state?.numberOfClients < 2 && state?.isPrimary && (
                        <Grid
                            item
                            cols={12}
                            lg={3}
                            sx={{
                                paddingTop: { xs: '32px !important', md: '0px !important' },
                            }}>
                            <AddPartnerTile
                                buttonSize={buttonSize}
                                fullHeight
                                isCustomerWebView={state?.isCustomerWebView}
                            />
                        </Grid>
                    )}
                </Grid>
                {state?.hasDocuments && (
                    <Grid container sx={{ justifyContent: 'flex-start' }}>
                        <Grid item cols={12} lg={4}>
                            <PastPlanTile
                                state={state}
                                setServiceError={setServiceError}
                                setPopupError={setOpen}
                                fullHeight
                            />
                        </Grid>

                        <Grid item cols={12} lg={4}>
                            <InsightsTile buttonSize={buttonSize} fullHeight />
                        </Grid>
                    </Grid>
                )}
            </Box>
        </HubPageBase>
    );
};

export default ConsentGiven;
